// https://gist.github.com/realmyst/1262561#gistcomment-1877648
export var createCountFormatter = function createCountFormatter(_ref) {
  var few = _ref.few,
      one = _ref.one,
      two = _ref.two;
  var titles = [one, two, few];
  return function (number) {
    var cases = [2, 0, 1, 1, 1, 2];
    return titles[number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]];
  };
};